.timeline-item {
    color: inherit;

    &__link {
        color: inherit;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}